import 'core-js/stable';
import 'regenerator-runtime/runtime';

import bugsnag from '@bugsnag/js';

if (process.env.RAILS_ENV !== 'test') {
  const options = process.env.RAILS_ENV === 'development' ? { logger: null } : {};

  const bugsnagClient = bugsnag({
    apiKey: '8aaa98e6bd89df72d4ba2e3934fd22ee',
    releaseStage: process.env.RAILS_ENV,
    notifyReleaseStages: ['staging', 'production'],
    ...options,
  });

  if (window.App.rails.user) {
    const { id, email } = window.App.rails.user;
    bugsnagClient.user = { id, email };
  } else if (window.App.rails.travel_helper) {
    const { id, email } = window.App.rails.travel_helper;
    bugsnagClient.user = { id, email };
  } else if (window.App.rails.admin) {
    const { id, email } = window.App.rails.admin;
    bugsnagClient.user = { id, email };
  }

  window.bugsnagClient = bugsnagClient;
}
